export const ROUTES = {
  HOME: "/",
  SIGNIN: "/signin",
  REGISTER: "/register",
  LOBBY: "/lobby",
};
